import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { circleBounce, circleBounceDataFromParticle } from "../../../Utils/Utils";
import { clamp, getDistance } from "../../../Utils/NumberUtils";
import { ParticlesInteractorBase } from "../../../Core/Utils/ParticlesInteractorBase";

function bounce(p1, p2) {
  circleBounce(circleBounceDataFromParticle(p1), circleBounceDataFromParticle(p2));
}

function destroy(p1, p2) {
  if (!p1.unbreakable && !p2.unbreakable) {
    bounce(p1, p2);
  }

  if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
    p1.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
    p2.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
    if (p1.getRadius() >= p2.getRadius()) {
      p2.destroy();
    } else {
      p1.destroy();
    }
  }
}

export var Collider =
/*#__PURE__*/
function (_ParticlesInteractorB) {
  _inherits(Collider, _ParticlesInteractorB);

  function Collider(container) {
    _classCallCheck(this, Collider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Collider).call(this, container));
  }

  _createClass(Collider, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.collisions.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var container, pos1, radius1, query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p2, pos2, dist, radius2, distP;

      return _regeneratorRuntime.async(function interact$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              container = this.container, pos1 = p1.getPosition(), radius1 = p1.getRadius(), query = container.particles.quadTree.queryCircle(pos1, radius1 * 2);
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 4;
              _iterator = query[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 18;
                break;
              }

              p2 = _step.value;

              if (!(p1 === p2 || !p2.options.collisions.enable || p1.options.collisions.mode !== p2.options.collisions.mode || p2.destroyed || p2.spawning)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("continue", 15);

            case 10:
              pos2 = p2.getPosition();

              if (!(Math.round(pos1.z) !== Math.round(pos2.z))) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("continue", 15);

            case 13:
              dist = getDistance(pos1, pos2), radius2 = p2.getRadius(), distP = radius1 + radius2;

              if (dist <= distP) {
                this.resolveCollision(p1, p2);
              }

            case 15:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 18:
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 24:
              _context.prev = 24;
              _context.prev = 25;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 27:
              _context.prev = 27;

              if (!_didIteratorError) {
                _context.next = 30;
                break;
              }

              throw _iteratorError;

            case 30:
              return _context.finish(27);

            case 31:
              return _context.finish(24);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[4, 20, 24, 32], [25,, 27, 31]]);
    }
  }, {
    key: "resolveCollision",
    value: function resolveCollision(p1, p2) {
      switch (p1.options.collisions.mode) {
        case "absorb":
          this.absorb(p1, p2);
          break;

        case "bounce":
          bounce(p1, p2);
          break;

        case "destroy":
          destroy(p1, p2);
          break;
      }
    }
  }, {
    key: "absorb",
    value: function absorb(p1, p2) {
      var container = this.container,
          fps = container.fpsLimit / 1000;

      if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
        p1.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
        p2.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        if (p1.getRadius() >= p2.getRadius()) {
          var factor = clamp(p1.getRadius() / p2.getRadius(), 0, p2.getRadius()) * fps;
          p1.size.value += factor;
          p2.size.value -= factor;

          if (p2.getRadius() <= container.retina.pixelRatio) {
            p2.size.value = 0;
            p2.destroy();
          }
        } else {
          var _factor = clamp(p2.getRadius() / p1.getRadius(), 0, p1.getRadius()) * fps;

          p1.size.value -= _factor;
          p2.size.value += _factor;

          if (p1.getRadius() <= container.retina.pixelRatio) {
            p1.size.value = 0;
            p1.destroy();
          }
        }
      }
    }
  }]);

  return Collider;
}(ParticlesInteractorBase);